module.exports = __webpack_public_path__ + "frontend/images/benefits/fraud-protection.gif?51604257f1f2f5d6e3a73841ea863cc1";